import environments from "../environment";

const SENSITIVE_KEYS = new Set([
	"token",
	"refreshToken",
	"refresh_token",
	"accessToken",
	"access_token",
	"password",
	"secret",
	"clientSecret",
	"authorization",
]);

function sanitize(value: any, depth = 0): any {
	if (depth > 3 || value == null) return value;
	if (typeof value === "string" && value.length > 20 && /^ey[A-Za-z0-9]/.test(value)) {
		return "[REDACTED JWT]";
	}
	if (Array.isArray(value)) {
		return value.map((v) => sanitize(v, depth + 1));
	}
	if (typeof value === "object") {
		const cleaned: Record<string, any> = {};
		for (const key of Object.keys(value)) {
			if (SENSITIVE_KEYS.has(key)) {
				cleaned[key] = "[REDACTED]";
			} else {
				cleaned[key] = sanitize(value[key], depth + 1);
			}
		}
		return cleaned;
	}
	return value;
}

export default class Logger {
	entityName: string;

	constructor(entityName: string) {
		this.entityName = entityName;
	}

	static getLogger(entityName: string) {
		return new Logger(entityName);
	}

	private getPrefix() {
		let prefix = `[${new Date().toLocaleString()}]`;
		if (this.entityName) {
			prefix += `[${this.entityName}]`;
		}
		return prefix;
	}

	direct(...args: any[]) {
		try {
			const prefix = this.getPrefix();
			const sanitizedArgs = args.map((a) => sanitize(a));

			if (sanitizedArgs.length > 0 && typeof sanitizedArgs[0] === "string") {
				console.log(prefix + " " + sanitizedArgs[0], ...sanitizedArgs.slice(1));
			} else {
				console.log(prefix + " ", ...sanitizedArgs);
			}
		} catch (err) {
			console.error(err);
		}
	}

	log(...args: any[]) {
		if (!environments.logMode) return;

		this.direct(...args);
	}

	warn(...args: any[]) {
		try {
			const prefix = this.getPrefix();
			const sanitizedArgs = args.map((a) => sanitize(a));
			console.warn(prefix + " ", ...sanitizedArgs);
		} catch (err) {
			console.error(err);
		}
	}

	error(...args: any[]) {
		try {
			const prefix = this.getPrefix();
			const sanitizedArgs = args.map((a) => sanitize(a));
			console.error(prefix + " ", ...sanitizedArgs);
		} catch (err) {
			console.error(err);
		}
	}
}
